
import { Input, Button, Form, FormItem } from 'element-ui';
import FacebookButton from '@/components/FacebookButton.vue';
import GoogleView from '@/components/GoogleView.vue';
import SocialLoginBtns from '@/pages/authenticate/components/SocialLoginBtns.vue';
import cartMixin from '@/mixins/cartMixin.js';
export default {
  mixins: [cartMixin],
  props: {
    tunnel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showInput: false,
      login: {
        user: '',
        pass: '',
      },
      rules: {
        user: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: this.$t('Please input correct email address'),
            trigger: 'blur',
          },
        ],
      },
      isLogin: false,
    };
  },
  methods: {
    openInput() {
      this.showInput = true;
      // this.$refs["email"].$el.focus()
      setTimeout(() => {
        this.$refs.email.focus();
      }, 200);
    },
    registerClick() {
      this.$refs['registerForm0'].validate((valid) => {
        if (valid) {
          const idCart = this.cartService.idCart;
          this.$store.dispatch('user/guest/setGuestUser', {
            user: null,
            cookies: this.$cookies,
          });
          this.$store.commit('cart/clear'); //23304

          this.cartService.setIdCartToCookies(idCart);

          this.$store.dispatch('user/guest/setEmailGuest', this.login.user);

          this.$router.push({
            path: this.localePath('/cart/delivery'),
          });
        } else {
          return false;
        }
      });
    },
    async glogin() {
      const googleUser = await this.$gAuth.signIn();
    },
  },
  components: {
    Input,
    Button,
    Form,
    FormItem,
    FacebookButton,
    GoogleView,
    SocialLoginBtns,
  },
};
